import { useState } from "react";

const DASHBOARD_API = process.env.REACT_APP_API_URL || "http://localhost:5050/api";

export default function ImpersonateModal({ isOpen, onClose, onSuccess }) {
  const [targetUsername, setTargetUsername] = useState("");
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const u = targetUsername.trim();
    if (!u) return;
    setError("");
    setLoading(true);
    try {
      const t   = sessionStorage.getItem("token");
      const res = await fetch(
        `${DASHBOARD_API}/impersonate/${encodeURIComponent(u)}?token=${t}`,
        { method: "POST" },
      );
      const d = await res.json();
      if (res.ok) {
        onSuccess(d.impersonating, d.token);
      } else {
        setError(d.error || "Impersonation failed.");
      }
    } catch {
      setError("Request failed. Check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setTargetUsername("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="port-modal-overlay open" onClick={handleClose}>
      <div className="port-modal" style={{ maxWidth: 400 }} onClick={(e) => e.stopPropagation()}>
        <div className="port-modal-header">
          <span>Admin View</span>
          <button className="port-modal-close" onClick={handleClose}>✕</button>
        </div>

        <div className="port-modal-body">
          <p style={{ marginBottom: 16, color: "var(--dash-muted)", fontSize: 13 }}>
            Enter the username of the user you want to act as. The session expires in 1 hour.
          </p>
          <form onSubmit={handleSubmit}>
            <label style={{ display: "block", marginBottom: 6, fontSize: 12, color: "var(--dash-muted)", fontFamily: "var(--dash-font-b)" }}>
              Username
            </label>
            <input
              type="text"
              placeholder="e.g. john.doe"
              value={targetUsername}
              onChange={(e) => setTargetUsername(e.target.value)}
              autoFocus
              style={{
                width: "100%", boxSizing: "border-box",
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: 4, padding: "8px 10px",
                color: "var(--dash-text)", fontSize: 13,
                fontFamily: "var(--dash-font-m)",
                outline: "none",
              }}
            />
            {error && (
              <div style={{ marginTop: 8, color: "var(--dash-red, #e05252)", fontSize: 12 }}>
                {error}
              </div>
            )}
            <div className="port-modal-footer" style={{ marginTop: 20 }}>
              <button type="button" className="port-btn-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="port-btn-primary" disabled={loading || !targetUsername.trim()}>
                {loading ? "Starting…" : "Start Session"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
